import { Alert } from '@heroui/react';
import { WarningCircleIcon } from '@phosphor-icons/react';

export default function ErrorBanner({ errMsg }: {
  errMsg: string
}) {
  if (!errMsg) return null;
  return (
    <Alert
      color="danger"
      variant="flat"
      title={errMsg}
      icon={<WarningCircleIcon size={20} weight="fill" />}
    />
  );
}
